import { useRef } from 'react';

import type { MapRef } from 'react-map-gl/mapbox';

export const useMapRefs = () => {
  const mapRef = useRef<MapRef>(null);

  return { mapRef };
};
